export default __webpack_public_path__ + "static/car-icon-c097f4db473de5a713302c051eb882dd.png";